const legacyFormPrefix = 'legacy-login-form';

export const legacyFormI18n = {
    subscriptionNotFound: {
        id: `${legacyFormPrefix}.subscriptionNotFound`,
        defaultMessage:
            'Your Seequent ID account {email} has not been linked to Imago. Learn more about',
    },
    sqidLink: {
        id: `${legacyFormPrefix}.sqidLink`,
        defaultMessage: 'Seequent ID with Imago',
    },
    signInUsernamePlaceholder: {
        id: `${legacyFormPrefix}.signInUsernamePlaceholder`,
        defaultMessage: 'Imago Username',
    },
    signInPasswordPlaceholder: {
        id: `${legacyFormPrefix}.signInPasswordPlaceholder`,
        defaultMessage: 'Imago Password',
    },
    signInButtonText: {
        id: `${legacyFormPrefix}.signInButtonText`,
        defaultMessage: 'Sign In With Imago ID',
    },
    signInErrorText: {
        id: `${legacyFormPrefix}.signInErrorText`,
        defaultMessage: 'Your username or password is incorrect. Please try again.',
    },
    legacyIdWarning: {
        title: {
            id: `${legacyFormPrefix}.legacyIdWarning.title`,
            defaultMessage: 'Legacy Imago ID',
        },
        textPart1: {
            id: `${legacyFormPrefix}.legacyIdWarning.textPart1`,
            defaultMessage:
                'Official support for Imago ID ended on 1st November 2024. Learn how to migrate to ',
        },
        textPart2: {
            id: `${legacyFormPrefix}.legacyIdWarning.textPart2`,
            defaultMessage: 'Seequent ID with Imago',
        },
    },
} as const;
